export default {
    state: {
        recurringSmsCampaign: localStorage.getItem('recurringSmsCampaign') ?? {}
    },
    mutations: {
        setRecurringSMSCampaign(state, campaign) {
            state.recurringSmsCampaign = campaign
        }
    },
    actions: {
        setCurrentRecurringSMSCampaign({ commit }, campaign) {
            localStorage.setItem('recurringSmsCampaign', campaign)
            commit('setRecurringSMSCampaign', campaign)
        }
    },
    getters: {
        getCurrentRecurringSMSCampaign: state => state.recurringSmsCampaign
    }
}
